import React, {Component} from 'react';

class InternetStep extends Component {
  render() {
    return (
      <div>
          <h1> This is InternetStep </h1>
      </div>
    )
  }
}

export default InternetStep;